{
  "instructions": "Introduzca su dirección de correo electrónico y le enviaremos un correo electrónico con instrucciones para restablecer su ontraseña.",
  "forgot-your-pass": "¿Olvidó su contraseña?",
  "send-email": "Enviar correo electronico",
  "email": "Correo electrónico",
  "go-login": "Volver a login",
  "email-sent": "Correo Enviado",
  "error": "Un Error Ocurrio",
  "emailLabel": "Correo electrónico",
  "lost-password": "¿Olvidó su contraseña?",
  "send-link": "Enviar enlace de acceso por correo",
  "login": "Iniciar sesión",
  "error-message": "Hubo un error. Por favor, inténtelo de nuevo.",
  "password": "Contraseña",
  "back": "Atrás",
  "type-email-message": "Escriba su dirección de correo electrónico, recibirá un secreto para cambiar su contraseña.",
  "copy-secret-message": "Copie el secreto enviado por correo electrónico y péguelo en el campo correspondiente, luego escriba su nueva contraseña y confírmela.",
  "secret": "Secreto",
  "confirm-password": "Confirmar contraseña",
  "change-password": "Cambiar contraseña",
  "request-secret": "Solicitar secreto",
  "request-new-secret": "Solicitar nuevo secreto",
  "already-have-secret": "Ya tengo un secreto",
  "email-sent-success": "¡Correo enviado!",
  "welcome": "Bienvenido.",
  "error-try-again": "Hubo un error, por favor intente de nuevo.",
  "sign-in-with-oauth": "Iniciar sesión",
  "oauth-error": "No pudimos completar el inicio de sesión. Por favor, inténtelo de nuevo.",
  "redirecting": "Redirigiendo…",
  "email-bootstrap-error": "Este enlace no es válido o ha expirado. Solicite uno nuevo.",
  "email-bootstrap-confirm": "Continuar iniciando sesión",
  "degraded-banner": "Conexión perdida. Reintentando su sesión…",
  "wopi-loading": "Abriendo el editor…",
  "wopi-reauth": "No pudimos renovar la sesión del editor. Reintente para seguir editando.",
  "or": "o",
  "email-link-title": "Iniciar sesión con correo",
  "email-link-description": "Le enviaremos un enlace de inicio de sesión seguro.",
  "email-sent-detail": "Enviamos un enlace de inicio de sesión a {{email}}.",
  "back-to-sign-in": "Volver a iniciar sesión",
  "password-updated": "Su contraseña ha sido actualizada."
}
